<script>
	import { projectSettings, acceptedFileUploadList } from "../../config";
	import { pageNumber, model } from "../../stores";
	import DropZone from "../../components/DropZone.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import { getTealiumID } from "../../tealium";

	export let title = null;
	export let pageIndex = null;
	export let pageTitle = null;
	export let disabled = false;
	export let nextPage = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	let id = "fileUploader";
	let options = {
		url: "/api/file-upload?token=" + $model.RegistrationToken,
		acceptedFiles: acceptedFileUploadList
	};

	if (!disabled) {
		$pageNumber = pageIndex;
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle || `${projectSettings.classActionName} - Review`;
		$model.TealiumId = $model.TealiumId || getTealiumID();
	}
	$model.documentList = $model.documentList || [];
</script>

<section>
	{#if !disabled}
		<h1>Supporting Documentation</h1>

		<p>
			Please provide documentary evidence of your trading in EML shares. Supporting documents may include holding
			statements, buy and sell contract notes, CHESS statements or broker account statements.
		</p>
		<p>
			If you are unable to provide documentary evidence, please provide a statutory declaration as to the truth
			and accuracy of the information you are providing about your trading in EML shares. You can do this using
			the statutory declaration form, which can be downloaded <a
				target="_blank"
				rel="noopener noreferrer"
				href="https://www.ag.gov.au/legal-system/statutory-declarations">Here</a
			>
		</p>

		<div class="form-row">
			<div class="form-group col-md-12">
				<DropZone
					{options}
					{id}
					message="Drop files here or click to upload for this registration"
					bind:documentList={$model.documentList}
				></DropZone>
			</div>
		</div>

		<div class="form-group form-row">
			<div class="col-md-12 last">
				<NavigationButtons {persistUrl} {previousPage} {nextPage} tealiumTag={true} pageName={title}
				></NavigationButtons>
			</div>
		</div>
	{:else}
		<div class="form-group">
			<h2>Uploaded Documents</h2>

			{#if $model.documentList && $model.documentList.length > 0}
				<table class="table table-sm">
					<tr>
						<th>Document Name</th>
					</tr>
					{#each $model.documentList as file}
						<tr>
							<td>{file.fileName}</td>
						</tr>
					{/each}
				</table>
			{:else}
				<p>No documents uploaded</p>
			{/if}
		</div>
	{/if}
</section>
